import { useEffect, memo } from 'react';
import { Outlet } from 'react-router-dom';

import useMediaQuery from '@mui/material/useMediaQuery';
import Toolbar from '@mui/material/Toolbar';
import Box from '@mui/material/Box';

// project imports
import Drawer from './Drawer';
import Header from './Header';
import Footer from './Footer';
import Loader from 'components/Loader';
import LockedMenuPromptModal from 'components/subscription/LockedMenuPromptModal';

import { handlerDrawerOpen, useGetMenuMaster } from 'api/menu';
import { DRAWER_WIDTH, MINI_DRAWER_WIDTH } from 'config';

// ==============================|| MAIN LAYOUT ||============================== //

const MainContentArea = memo(function MainContentArea() {
  return (
    <Box
      sx={{
        px: { xs: 0, sm: 1, md: 2 },
        position: 'relative',
        minHeight: 'calc(100vh - 110px)',
        display: 'flex',
        flexDirection: 'column',
        minWidth: 0
      }}
    >
      <Outlet />
      <Footer />
    </Box>
  );
});

export default function DashboardLayout() {
  const { menuMaster, menuMasterLoading } = useGetMenuMaster();
  const drawerOpen = menuMaster?.isDashboardDrawerOpened;
  const downXL = useMediaQuery((theme) => theme.breakpoints.down('xl'));

  // set media wise responsive drawer
  useEffect(() => {
    handlerDrawerOpen(!downXL);
  }, [downXL]);

  if (menuMasterLoading) return <Loader />;

  return (
    <Box sx={{ display: 'flex', width: '100%', maxWidth: '100%', overflowX: 'hidden' }}>
      <Header />
      <Drawer />

      <Box
        component="main"
        sx={{
          width: { xs: '100%', lg: drawerOpen ? `calc(100% - ${DRAWER_WIDTH}px)` : `calc(100% - ${MINI_DRAWER_WIDTH}px)` },
          transition: 'none',
          minWidth: 0,
          p: { xs: 1.5, sm: 2, md: 3 },
          overflowX: 'hidden',
          bgcolor: 'background.default'
        }}
      >
        <Toolbar sx={{ mt: 'inherit' }} />
        <MainContentArea />
      </Box>
      <LockedMenuPromptModal />
    </Box>
  );
}